/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, replacePXinStringWithEM} from '@insticator/insticator-ui';
import {hoverTransition} from '../../utils/styles/general';


/* ++++++++++ --------------- app.filters : STYLES --------------- ++++++++++ */
export default {
    globalFilter: {
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        gap: pxToEm(12),
        '& .name-filters': {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: pxToEm(12),
            '& .items': {
              height: 'initial',
              minHeight: pxToEm(120),
              maxHeight: pxToEm(240),
              '& .sublist': {
                paddingBottom: 0
              }
            },
            '& .filter-site': {zIndex: '4',  maxWidth: '17em'},
            '& .filter-device': {zIndex: '3',  maxWidth: '15em',
                '& .divider': { margin: 0}
            },
            '& .filter-country': {zIndex: '2',  maxWidth: '17em'},
        },
        '& .datepickerdropdown': {
            zIndex: '9'
        }
    },
    // wrap date dropdown when screen width small
    [`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(885)})`]: {
        globalFilter: {
            flexWrap: 'wrap',
        }
    }
};
